import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

interface Data {
  title: string
  value: string
}

interface CustomChartTooltipProps {
  data?: Data[]
  title?: string
}

const CustomChartTooltip = ({ title, data }: CustomChartTooltipProps) => {
  const theme = useTheme()

  return (
    <Card>
      {title && (
        <Box sx={{ background: theme.palette.grey[200], textAlign: 'center', py: 0.5 }}>
          <Typography variant="caption" fontWeight={500}>
            {title}
          </Typography>
        </Box>
      )}
      <Box sx={{ p: 2 }}>
        {data?.map((el, idx) => (
          <Stack direction="row" spacing={1} alignItems="center" key={`${el.title}-${idx}`}>
            <Typography variant="caption">{el.title}</Typography>
            <Typography variant="caption" sx={{ fontWeight: 600 }}>
              {el.value}
            </Typography>
          </Stack>
        ))}
      </Box>
    </Card>
  )
}

export default CustomChartTooltip
